var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-search-wrapper" }, [
    _c("div", { staticClass: "search-tab" }, [
      _c(
        "span",
        {
          class: { selected: _vm.selectedTab === 0 },
          on: {
            click: function($event) {
              return _vm.handleTabClick(0)
            }
          }
        },
        [_vm._v("应用")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          class: { selected: _vm.selectedTab === 1 },
          on: {
            click: function($event) {
              return _vm.handleTabClick(1)
            }
          }
        },
        [_vm._v("供应商")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search-input-wrapper" }, [
      _c("i", { class: ["iconfont", "icon-search"] }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchKeywords,
            expression: "searchKeywords"
          }
        ],
        attrs: { placeholder: _vm.palceholder[_vm.selectedTab] },
        domProps: { value: _vm.searchKeywords },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.handleSearch($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchKeywords = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("button", { on: { click: _vm.handleSearch } }, [_vm._v("搜索")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-724bda8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-724bda8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/search.vue
// module id = dSrF
// module chunks = 1 2 3 4 5 6 7 8 9